// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": "#ffcb0b",
	"primaryDark": "#f3bf00",
	"primaryLight": "#ffd53c",
	"secondary": "#1f1a17",
	"regular": "\"SF_Regular\", sans-serif",
	"medium": "\"Sf_Ui_Medium\", sans-serif",
	"semibold": "\"Sf_Ui_Semibold\", sans-serif"
};
export default ___CSS_LOADER_EXPORT___;
